import { Module } from 'vuex'
import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'
import { InitialState, OtherEquipmentConnectionState } from './types'
import { address } from './address'
import { configurationInfo } from './configuration-info'
import { contactInfo } from './contact-info'
import { vatInfo } from './vat-info'
import { attachment } from './attachment'
import { RootState } from '@/store/types';

const namespaced: boolean = true

export const otherEquipmentConnection: Module<OtherEquipmentConnectionState, RootState> = {
  namespaced,
  state: InitialState,
  getters,
  actions,
  mutations,
  modules: {
    address,
    configurationInfo,
    contactInfo,
    vatInfo,
    attachment
  }
}
